import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'
import posed from 'react-pose'
import easing from 'ui/styles/easing'

import IconPlus from './IconPlus'

// Animations
const PosedContent = posed.div({
  closed: {
    height: 0
  },
  open: {
    height: 'auto'
  }
})

// Styles
const Container = styled.div`
  border-bottom: 1px solid ${props => props.theme.colors.grey.base};
`

const TitleBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  color: ${props => props.theme.colors.grey.dark};
  transition: color 0.3s ${easing.easeOutCubic};

  &:hover {
    cursor: pointer;
    color: ${props => props.theme.colors.theme.base};
  }
`

const Title = styled.h2`
  font-size: 22px;
  line-height: 28px;
  margin-bottom: 0;
  color: inherit;
`

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 1em;
  flex-shrink: 0;

  > div {
    margin-left: 1em;
  }
`

const CTA = styled.span`
  font-size: 14px;
  color: ${props => props.theme.colors.grey.dark};

  ${media.xs`
    display: none;
  `}
`

const Content = styled(PosedContent)`
  overflow: hidden;
  font-weight: 300;
  line-height: 21px;
  color: ${props => props.theme.colors.grey.darker};
  padding-right: 100px;
`

export default class Accordion extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }

  state = {
    open: false
  }

  openAccordion() {
    this.setState({ open: !this.state.open })
  }
  
  render() {
    const {
      open
    } = this.state

    const {
      title,
      text
    } = this.props

    return(
      <Container>
        <TitleBar
          onClick={() => this.openAccordion()}
          innerRef={this.titleBar}
        >
          <Title>{title}</Title>
          <ButtonContainer>
            <CTA>{open ? 'Skjul indhold' : 'Vis indhold'}</CTA>
            <IconPlus open={open} />
          </ButtonContainer>
        </TitleBar>
        <Content
          pose={open ? 'open' : 'closed'}
          innerRef={this.content}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/Accordions/Accordion.js